module.exports = __webpack_public_path__ + "bcac35bdc12e7f07cf457be48dfec9fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/visa_2022_chart.png
// module id = 1759
// module chunks = 0